import { Fragment } from "react";

import { createArray } from "@/utils/utility";

import { Box, CardContent, Divider, Stack, Typography } from "@mui/material";
import {
  areIntervalsOverlapping,
  endOfMonth,
  format,
  isSameSecond,
  setMonth,
  startOfMonth,
  startOfSecond,
  startOfYear,
} from "date-fns";
import PropTypes from "prop-types";

import CalendarCard from "./CalendarCard";

function EventView({ yearlyHolidays, viewDate, setHoliday, getGoTo }) {
  return (
    <CardContent>
      <Stack
        sx={{
          gap: 1,
          mx: "auto",
          maxWidth: 560,
        }}
      >
        {createArray(0, 12).map((item) => {
          const currentMonth = setMonth(startOfYear(viewDate), item);
          const monthlyHolidays = yearlyHolidays.filter(
            (holiday) =>
              areIntervalsOverlapping(
                { start: startOfMonth(currentMonth), end: endOfMonth(currentMonth) },
                { start: holiday.start, end: holiday.end },
              ) && !isSameSecond(startOfSecond(holiday.end), startOfMonth(currentMonth)),
          );

          return (
            <Fragment key={item}>
              {item !== 0 && <Divider sx={{ my: 0.5 }} />}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "160px 1fr" },
                  alignItems: "flex-start",
                  gap: { xs: 1, md: 2 },
                }}
              >
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    height: 36,
                  }}
                >
                  <Typography variant="h5" component="h4" sx={{ m: 0 }}>
                    {format(currentMonth, "MMMM")}
                  </Typography>
                </Stack>
                <Stack
                  sx={{
                    gap: 0.5,
                  }}
                >
                  {monthlyHolidays.length >= 1 ? (
                    monthlyHolidays.map((holiday) => (
                      <CalendarCard
                        key={holiday.id}
                        holiday={holiday}
                        viewDate={currentMonth}
                        onClick={() => setHoliday(holiday)}
                        getGoTo={getGoTo}
                      />
                    ))
                  ) : (
                    <Stack
                      direction="row"
                      sx={{
                        gap: 1,
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: { xs: "auto", md: 36 },
                      }}
                    >
                      <Typography variant="body2">No holidays</Typography>
                    </Stack>
                  )}
                </Stack>
              </Box>
            </Fragment>
          );
        })}
      </Stack>
    </CardContent>
  );
}

EventView.propTypes = {
  yearlyHolidays: PropTypes.array,
  viewDate: PropTypes.number,
  setHoliday: PropTypes.func,
  getGoTo: PropTypes.func,
};

export default EventView;
